import { useState } from "react";
import Seo from "@/components/Seo";
import { useLang, route } from "../i18n";
import { useCompany, useSitePosts } from "../components/SiteContext";
import { CATEGORIES } from "../data/posts";
import PageHero from "../components/PageHero";
import BlogCard from "../components/BlogCard";
import FinalCta from "../components/FinalCta";
import { track } from "../lib/track";

const Blog = () => {
  const { lang, t } = useLang();
  const company = useCompany();
  const allPosts = useSitePosts();
  const b = t.blogPage;
  const [filter, setFilter] = useState("all");

  const usedCats = [...new Set(allPosts.map((p) => p.category))];
  const published = allPosts.filter((p) => p.status === "published");
  const featured = filter === "all" ? published[0] : null;
  const gridPosts = (filter === "all" ? allPosts : allPosts.filter((p) => p.category === filter)).filter(
    (p) => p.slug !== featured?.slug,
  );

  return (
    <>
      <Seo title={b.seo.title} siteName={company.name} description={b.seo.description} />
      <PageHero
        eyebrow={b.eyebrow}
        lines={[b.title]}
        copy={b.copy}
        breadcrumb={[{ label: t.nav.home, to: route(lang, "home") }, { label: t.nav.blog }]}
        testid="blog-hero"
      />

      <section className="bg-[#F4F0E8]" data-testid="blog-index">
        <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
          <div className="flex flex-wrap gap-2" data-testid="blog-filters">
            <button
              onClick={() => setFilter("all")}
              data-testid="filter-all"
              className={`border px-4 py-2 text-[0.62rem] uppercase tracking-[0.16em] transition-colors ${
                filter === "all"
                  ? "border-[#171717] bg-[#171717] text-[#F4F0E8]"
                  : "border-[#171717]/20 text-[#171717]/70 hover:border-[#C6A46A]"
              }`}
            >
              {b.all}
            </button>
            {usedCats.map((c) => (
              <button
                key={c}
                onClick={() => { setFilter(c); track("blog_filter", { category: c }); }}
                data-testid={`filter-${c}`}
                className={`border px-4 py-2 text-[0.62rem] uppercase tracking-[0.16em] transition-colors ${
                  filter === c
                    ? "border-[#171717] bg-[#171717] text-[#F4F0E8]"
                    : "border-[#171717]/20 text-[#171717]/70 hover:border-[#C6A46A]"
                }`}
              >
                {CATEGORIES[c]?.[lang] || c}
              </button>
            ))}
          </div>

          {featured && (
            <div className="mt-12">
              <BlogCard post={featured} large />
            </div>
          )}

          <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {gridPosts.map((p) => (
              <BlogCard key={p.slug} post={p} />
            ))}
          </div>
        </div>
      </section>

      <FinalCta />
    </>
  );
};

export default Blog;
